/**
 * 普通接口路径
 */
const apiUrl = (source) => {
  let url = `api/${source}`;
  return `${url}`;
};
/**
 * 直接挂域名下的接口
 */
const fileUrl = (source) => {
  return `${source}`;
};

export { apiUrl, fileUrl };
